import { buildTestAttribute, buildTestAttributeSelector } from './logzTestGenerator';
export var NotificationSelectors;
(function (NotificationSelectors) {
    let notificationAttributesName;
    (function (notificationAttributesName) {
        notificationAttributesName["Context"] = "context";
        notificationAttributesName["Type"] = "type";
        notificationAttributesName["Subject"] = "subject";
    })(notificationAttributesName || (notificationAttributesName = {}));
    NotificationSelectors.attributes = {
        type: buildTestAttribute(notificationAttributesName.Type),
    };
    NotificationSelectors.selectAllNotifications = '.rc-notification-notice';
    NotificationSelectors.selectAllNotificationCloseButton = '.rc-notification-notice-close';
    const selectNotificationContent = buildTestAttributeSelector(notificationAttributesName.Context, 'notification');
    const byType = (type) => `.notification-type-${type}`;
    const bySubject = (subject) => `.subject-${subject}`;
    NotificationSelectors.bySubjectAndType = (subject, type) => `${NotificationSelectors.selectAllNotifications}${byType(type)}${bySubject(subject)}`;
    NotificationSelectors.selectCloseButtonBySubjectAndType = (subject, type) => `${NotificationSelectors.bySubjectAndType(subject, type)} ${NotificationSelectors.selectAllNotificationCloseButton}`;
    NotificationSelectors.selectCloseButtonByType = (type) => `${byType(type)} ${NotificationSelectors.selectAllNotificationCloseButton}`;
})(NotificationSelectors || (NotificationSelectors = {}));
//# sourceMappingURL=notification.selectors.js.map